import { render, staticRenderFns } from "./deactivateAccount.vue?vue&type=template&id=11f2f163&scoped=true&"
import script from "./deactivateAccount.vue?vue&type=script&lang=js&"
export * from "./deactivateAccount.vue?vue&type=script&lang=js&"
import style0 from "./deactivateAccount.vue?vue&type=style&index=0&id=11f2f163&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f2f163",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11f2f163')) {
      api.createRecord('11f2f163', component.options)
    } else {
      api.reload('11f2f163', component.options)
    }
    module.hot.accept("./deactivateAccount.vue?vue&type=template&id=11f2f163&scoped=true&", function () {
      api.rerender('11f2f163', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/profile/deactivateAccount.vue"
export default component.exports